<template>
  <div class="wrapper">
    <div class="container">
      <Header :name="$t('app.contact.header')" />
      <div class="card">
        <div class="block">
          <h2>{{ $t("app.contact.needMoreEvaluations") }}</h2>
          <p>{{ $t("app.contact.personalizedSupport") }}</p>
        </div>
        <div class="block-avantages">
          <p class="bold">{{ $t("app.contact.yourAdvantages") }}</p>
          <div class="avantages-list">
            <div class="avantage">{{ $t("app.contact.advantage.preferentialRate") }}</div>
            <div class="avantage">{{ $t("app.contact.advantage.unlimitedUsers") }}</div>
            <div class="avantage">{{ $t("app.contact.advantage.unlimitedFeatures") }}</div>
          </div>
        </div>
        <p class="bold">
          {{ $t("app.contact.contactUs") }}
        </p>
        <img src="@/assets/images/img/team.webp" alt="Yuzu team" />
      </div>
    </div>
    <div v-if="!isUserPending" class="form-side">
      <img src="@/assets/images/element/lemon.svg" alt="Yuzu lemon" class="lemon bg-pattern" />
      <img src="@/assets/images/element/zeste.svg" alt="Yuzu zeste" class="zeste bg-pattern" />
      <img src="@/assets/images/element/dots-pattern.svg" alt="Yuzu dots pattern" class="dots-pattern bg-pattern" />
      <img src="@/assets/images/element/dots-pattern.svg" alt="Yuzu dots pattern" class="dots-pattern-2 bg-pattern" />
      <div class="card">
        <h4>{{ $t("app.contact.contactForm") }}</h4>
        <p>{{ $t("app.contact.verifyInfo") }}</p>
        <VForm
          :button="{
            label: $t('app.contact.sendMessage'),
            class: 'primary full-size',
            hotDisabled: true,
          }"
          :externalRule="message?.length > 0"
          :callback="submit"
        >
          <template #form-body>
            <div class="input-inline">
              <VField :label="$t('app.form.register.firstName')" name="firstname" v-model="user.personal_information.first_name" :disabled="true" />
              <VField :label="$t('app.form.register.lastName')" name="lastname" v-model="user.personal_information.last_name" :disabled="true" />
            </div>
            <VField :label="$t('app.form.email')" type="email" name="email" v-model="user.personal_information.email" :disabled="true" />
            <!-- <div class="input-wrapper">
              <label for="phone">{{ $t("app.form.register.phone") }}</label>
              <vue-tel-input id="phone" v-model="user.personal_information. phone_number" :disabled="true">
                <template v-slot:arrow-icon>
                  <i class="bi bi-chevron-down" />
                </template>
              </vue-tel-input>
            </div> -->
            <VTextarea name="message" rows="3" :modelValue="message" @input="(event) => (message = event.target.value)" />
            <p class="small"><span class="bold">Yuzu</span> {{ $t("app.contact.privacyNotice") }}</p>
          </template>
        </VForm>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { ref } from "vue";

import Header from "@/components/Header.vue";
import { getError } from "@/composables/error.js";

import { useUser } from "@/queries/user.query";
import { userApi } from "@/api/user.api";

const toast = useToast();
const route = useRoute();
const { t } = useI18n();

const { data: user, isPending: isUserPending } = useUser();

const message = ref(null);

async function submit() {
  if (!message.value) return;

  try {
    await userApi.contactYuzu(route.params.companyId as string, message.value);
    toast.success(t("app.contact.successMessage"));
  } catch (e) {
    toast.error(getError(e?.key || e));
  }

  message.value = "";
}
</script>
